module.exports = __webpack_public_path__ + "img/img-illust-food.0dacbe92.svg";